<template>
  <div id="documents">
    <div class="container">
      <DocumentsComponent />
    </div>
  </div>
</template>

<script>
import InfoBlock from "../modules/InfoBlock";
import $ from "jquery"

import DocumentsComponent from "../components/event/Documents.vue";
export default {
  name: "Documents",
  components: { DocumentsComponent, InfoBlock },
  methods: {},
    mounted() {
      $("html, body").animate({ scrollTop: 0 }, 350);
  },
  computed: {
    currentEvent() {
      return this.$store.getters.getEvent;
    },
  }
};
</script>

<style lang="less">
#documents {
  background-color: #F1F3F6;



  min-height: calc(~"100vh");
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0px 20px;

  .container {
    display: block;
    max-width: 1120px;
    width: inherit;
    margin: 0 auto;
    margin-bottom: 40px;
  }
}

@media (max-width: 768px) {
  #documents {
    padding: 0px;
    padding-bottom: 60px;
    .container {
      padding: 0px 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Documents.vue